<div
  *ngIf="isOriginalProduct && !banner && !isPartialReserve"
  id="original-product"
>
  <div class="exception-img">
    <img
      src="{{ thumbnailImageURL }}"
      (error)="
        this.thumbnailImageURL = getAternativeThumbnail(thumbnailImageURL)
      "
      *ngIf="!!thumbnailImageURL && !isOffline"
      [attr.data-cy]="
        'exception-product-' + product?.productNumber + '-thumbnail-image'
      "
      class="product-image"
    />
    <ion-icon
      name="restaurant"
      *ngIf="!thumbnailImageURL || isOffline"
      class="product-image no-image"
      data-cy="exception-product-no-image-icon"
    ></ion-icon>
  </div>
  <div
    class="red-banner"
    *ngIf="exceptionResolution?.orderException?.errorMessage"
    [attr.data-cy]="
      'exception-product-' + product?.productNumber + '-error-message'
    "
  >
    <ion-icon name="alert-circle-outline"></ion-icon
    ><span
      >{{ exceptionResolution?.orderException?.errorMessage }} <br />
      <ng-container *ngIf="exceptionResolution?.orderException?.inStockDate">
        {{ 'i18n.orderExceptionsPage.expectedInStock' | translate }}
        {{
          exceptionResolution?.orderException?.inStockDate
            | date: 'M/d' : 'GMT'
        }}.
      </ng-container></span
    >
  </div>
  <div class="product-information">
    <div>
      <div
        class="brand"
        [attr.data-cy]="
          'exception-product-' + product?.productNumber + '-brand-text'
        "
      >
        {{ product?.summary?.brand | acronymTitleCase }}
      </div>
      <div
        class="description"
        [attr.data-cy]="
          'exception-product-' + product?.productNumber + '-description-text'
        "
      >
        {{ product?.summary?.productDescTxtl | acronymTitleCase }}
      </div>
      <div class="product-number-pack-size">
        <span
          [attr.data-cy]="
            'exception-product-' + product?.productNumber + '-number-text'
          "
          >#{{ product?.productNumber }}</span
        >
        <span class="border">|</span>
        <span
          [attr.data-cy]="
            'exception-product-' + product?.productNumber + '-pack-size-text'
          "
        >
          {{ product?.summary?.salesPackSize }}</span
        >
      </div>
      <div
        class="case-each"
        [attr.data-cy]="
          'exception-product-' + product?.productNumber + '-unit-price-text'
        "
      >
        {{
          (exceptionResolution?.orderItem?.unitPrice | currency) || 'loading..'
        }}
        {{ exceptionResolution?.orderItem?.priceUOM || 'CS' }}
        <span
          *ngIf="product?.summary?.breakable"
          [attr.data-cy]="
            'exception-product-' + product?.productNumber + '-each-price-text'
          "
        >
          /
          {{
            (exceptionResolution?.orderItem?.eachPrice | currency) ||
              'loading..'
          }}
          {{ exceptionResolution?.orderItem?.priceUOM === 'LB' ? 'LB' : 'EA' }}
        </span>
      </div>
      <div
        class="ordered"
        [attr.data-cy]="
          'exception-product-' + product?.productNumber + '-ordered-text'
        "
      >
        <span>{{ 'i18n.common.ordered' | translate }}:</span>
        {{ exceptionResolution?.orderItem?.unitsOrdered.currentValue || 0 }}
        CS /
        {{ exceptionResolution?.orderItem?.eachesOrdered.currentValue || 0 }}
        EA
      </div>
      <div
        class="reserved"
        [attr.data-cy]="
          'exception-product-' + product?.productNumber + '-reserved-text'
        "
      >
        <span>{{ 'i18n.common.reserved' | translate }}:</span>
        {{ exceptionResolution?.orderItem?.unitsReserved || 0 }} CS /
        {{ exceptionResolution?.orderItem?.eachesReserved || 0 }} EA
      </div>
    </div>

    <span
      class="button-wrapper"
      *ngIf="
        !isPartialReserve &&
        (exceptionType === exceptionTypes.OUT_OF_STOCK ||
          exceptionType === exceptionTypes.RESTRICTED ||
          exceptionType === exceptionTypes.PRODUCT_UNAVAILABLE)
      "
    >
      <ion-button
        *ngIf="exceptionType === exceptionTypes.OUT_OF_STOCK"
        [ngClass]="{
          'usf-fill-disabled-button':
            exceptionResolution?.resolutionType === 'Waiting for Restock',
          'usf-fill-green-button':
            exceptionResolution?.resolutionType !== 'Waiting for Restock',
        }"
        (click)="
          exceptionResolution?.resolutionType !== 'Waiting for Restock'
            ? onExceptionResolution(ResolutionType.WAIT_FOR_RESTOCK)
            : null
        "
        data-cy="add-to-waitlist-button"
        >{{ 'i18n.orderExceptionsPage.doNotSub' | translate }}</ion-button
      >

      <ion-button
        [ngClass]="{
          'usf-outline-green-button':
            exceptionType === exceptionTypes.OUT_OF_STOCK,
          'usf-fill-green-button':
            exceptionType !== exceptionTypes.OUT_OF_STOCK,
        }"
        class="remove-button"
        (click)="
          exceptionResolution?.resolutionType !== 'Removed'
            ? onExceptionResolution(ResolutionType.REMOVE)
            : null
        "
        >{{ 'i18n.orderExceptionsPage.remove' | translate }}</ion-button
      >
    </span>
  </div>
</div>

<div
  *ngIf="!isOriginalProduct && !banner && !hideProduct"
  id="substitute-product"
>
  <div class="exception-img">
    <img
      src="{{ thumbnailImageURL }}"
      (error)="
        this.thumbnailImageURL = getAternativeThumbnail(thumbnailImageURL)
      "
      *ngIf="!!thumbnailImageURL && !isOffline"
      [attr.data-cy]="
        'subsitute-product-' + product?.productNumber + '-thumbnail-image'
      "
      class="product-image"
    />
    <ion-icon
      name="restaurant"
      *ngIf="!thumbnailImageURL || isOffline"
      class="product-image no-image"
      data-cy="exception-sub-product-no-image-icon"
    ></ion-icon>
  </div>
  <div class="product-information">
    <div>
      <div
        class="brand"
        [attr.data-cy]="
          'subsitute-product-' + product?.productNumber + '-brand-text'
        "
      >
        {{ product?.summary?.brand | acronymTitleCase }}
      </div>
      <div
        class="description"
        [attr.data-cy]="
          'subsitute-product-' + product?.productNumber + '-description-text'
        "
      >
        {{ product?.summary?.productDescTxtl | acronymTitleCase }}
      </div>
      <div class="product-number-pack-size">
        <span
          [attr.data-cy]="
            'subsitute-product-' + product?.productNumber + '-number-text'
          "
          >#{{ product?.summary?.productNumber }}</span
        >
        <span class="border">|</span>
        <span
          [attr.data-cy]="
            'subsitute-product-' + product?.productNumber + '-pack-size-text'
          "
        >
          {{ product?.summary?.salesPackSize }}</span
        >
      </div>
      <div
        class="case-each"
        [attr.data-cy]="
          'subsitute-product-' + product?.productNumber + '-unit-price-text'
        "
      >
        {{ (product?.pricing?.unitPrice | currency) || 'loading..' }}
        {{ product?.pricing?.priceUom || 'CS' }}
        <span
          *ngIf="product?.summary?.breakable"
          [attr.data-cy]="
            'subsitute-product-' + product?.productNumber + '-each-price-text'
          "
        >
          /
          {{ (product?.pricing?.eachPrice | currency) || 'loading..' }}
          {{ product?.pricing?.priceUom === 'LB' ? 'LB' : 'EA' }}
        </span>
      </div>
    </div>
    <div class="usf-order-card-info-product-tags">
      <div class="product-tag-wrap" *ngIf="product?.productTags?.length > 0">
        <app-usf-product-tag-list
          [tagList]="product.productTags?.slice(0, this.maxDisplayTags)"
          [allTagsClickable]="true"
        >
        </app-usf-product-tag-list>
      </div>
    </div>
    <div class="button-wrapper">
      <a
        class="usf-green-link"
        data-cy="flip-product-card-button"
        (click)="showFlipSide()"
      >
        {{
          exceptionType === exceptionTypes.PRODUCT_UNAVAILABLE
            ? ('i18n.orderExceptionsPage.selectReplacement' | translate)
            : ('i18n.orderExceptionsPage.selectSubstitute' | translate)
        }}</a
      >
    </div>
  </div>
  <app-flipside-product-desktop
    @slideInOut
    *ngIf="isFlipsideVisible"
    [exceptionResolution]="exceptionResolution"
    [exceptionType]="exceptionType"
    [product]="product"
    [subOrderItem]="subOrderItem"
    [isPackSizeDifferent]="
      originalProduct?.summary?.salesPackSize !==
      product?.summary?.salesPackSize
    "
    [platformEnum]="platformEnum"
    (exceptionResolved)="onSubSelected($event)"
    (backButtonClicked)="showFlipSide()"
  ></app-flipside-product-desktop>
  <div
    @fadeInOut
    class="disabled-substitute-card"
    *ngIf="
      exceptionResolution?.flippedProductNumber &&
      exceptionResolution?.flippedProductNumber !== product.productNumber
    "
  ></div>
</div>

<div id="banner" *ngIf="!isOriginalProduct && banner">
  <div class="banner-title" data-cy="exception-product-banner-text">
    {{ exceptionResolution?.resolutionType }}
  </div>
  <div class="exceptions-completed-product-info">
    <div class="exception-img">
      <img
        src="{{ thumbnailImageURL }}"
        (error)="
          this.thumbnailImageURL = getAternativeThumbnail(thumbnailImageURL)
        "
        *ngIf="!!thumbnailImageURL && !isOffline"
        [attr.data-cy]="'banner-product-' + product?.productNumber + '-image'"
        class="product-image"
      />
      <ion-icon
        name="restaurant"
        *ngIf="!thumbnailImageURL || isOffline"
        data-cy="exception-banner-product-no-image-icon"
        class="product-image no-image"
      ></ion-icon>
    </div>
    <div class="exceptions-completed-product-info-inner">
      <div
        class="brand-and-product-number"
        [attr.data-cy]="
          'banner-product-' + product?.productNumber + '-brand-number-text'
        "
      >
        {{ product?.summary.brand | acronymTitleCase }}
        <span class="border">|</span> #{{ product?.summary?.productNumber }}
      </div>
      <div
        class="product-description"
        [attr.data-cy]="
          'banner-product-' + product?.productNumber + '-description-text'
        "
      >
        {{ product?.summary?.productDescTxtl | acronymTitleCase }}
      </div>
    </div>
  </div>
  <div
    class="edit-link"
    (click)="editRow()"
    data-cy="edit-sub-product-banner-link"
  >
    {{ 'i18n.common.edit' | translate }}
  </div>
</div>

<!-- Partial Unavailable  ------------------------------------   -->
<div id="partial-unavailable" *ngIf="isPartialReserve">
  <div>
    <div class="alert-message">
      <ion-icon name="alert-circle-outline"></ion-icon>
      <div data-cy="exception-partial-unavailable-message-text">
        {{ exceptionResolution?.orderException?.errorMessage }}
      </div>
    </div>

    <div class="product-information-wrapper">
      <div class="exception-img">
        <img
          src="{{ thumbnailImageURL }}"
          (error)="
            this.thumbnailImageURL = getAternativeThumbnail(thumbnailImageURL)
          "
          *ngIf="!!thumbnailImageURL && !isOffline"
          [attr.data-cy]="
            'partial-product-' + product?.productNumber + '-image'
          "
          class="product-image"
        />
        <ion-icon
          name="restaurant"
          *ngIf="!thumbnailImageURL || isOffline"
          data-cy="exception-partial-unavailable-no-image-icon"
          class="product-image no-image"
        ></ion-icon>
      </div>

      <div class="product-information">
        <div
          class="brand"
          [attr.data-cy]="
            'partial-product-' + product?.productNumber + '-brand-text'
          "
        >
          {{ product?.summary?.brand | acronymTitleCase }}
        </div>

        <div
          class="description"
          [attr.data-cy]="
            'partial-product-' + product?.productNumber + '-description-text'
          "
        >
          {{ product?.summary?.productDescTxtl | acronymTitleCase }}
        </div>
      </div>
    </div>

    <div class="case-each">
      <span
        [attr.data-cy]="
          'partial-product-' + product?.productNumber + '-number-text'
        "
        >#{{ product?.productNumber }}</span
      >
      <span class="border">|</span>
      <span
        [attr.data-cy]="
          'partial-product-' + product?.productNumber + '-pack-size-text'
        "
      >
        {{ product?.summary?.salesPackSize }}</span
      >
      <div>
        <strong>
          {{
            (exceptionResolution?.orderItem?.unitPrice | currency) ||
              'loading..'
          }}
          {{ exceptionResolution?.orderItem?.priceUOM || 'CS' }}

          <span
            *ngIf="product?.summary?.breakable"
            [attr.data-cy]="
              'partial-product-' + product?.productNumber + 'each-price-text'
            "
          >
            /
            {{
              (exceptionResolution?.orderItem?.eachPrice | currency) ||
                'loading..'
            }}
            {{
              exceptionResolution?.orderItem?.priceUOM === 'LB' ? 'LB' : 'EA'
            }}
          </span>
        </strong>
      </div>
    </div>

    <div
      class="ordered"
      [attr.data-cy]="
        'partial-product-' + product?.productNumber + 'ordered-text'
      "
    >
      <span>{{ 'i18n.common.ordered' | translate }}:</span>
      {{ exceptionResolution?.orderItem?.unitsOrdered.currentValue || 0 }}
      CS /
      {{ exceptionResolution?.orderItem?.eachesOrdered.currentValue || 0 }}
      EA
    </div>

    <div
      class="reserved"
      [attr.data-cy]="
        'partial-product-' + product?.productNumber + 'reserved-text'
      "
    >
      <span>{{ 'i18n.common.reserved' | translate }}:</span>
      {{ exceptionResolution?.orderItem?.unitsReserved || 0 }} CS /
      {{ exceptionResolution?.orderItem?.eachesReserved || 0 }} EA
    </div>

    <!-- show if partial -->
    <div
      class="selection-options"
      *ngIf="!exceptionResolution?.partialReserveFlag"
      data-cy="reserved-quantity-text"
    >
      <p>{{ 'i18n.orderExceptionsPage.reserveQuantityMessage' | translate }}</p>
      <p>
        <mat-radio-group
          class="mat-radio-options"
          [(ngModel)]="selectedReserveQuantityOption"
        >
          <mat-radio-button value="send" data-cy="send-to-waitlist-radio-button"
            ><span class="radio-button-label">
              {{
                exceptionType === exceptionTypes.PRODUCT_UNAVAILABLE
                  ? ('i18n.orderExceptionsPage.sendIt' | translate)
                  : ('i18n.orderExceptionsPage.sendItAndWaitlist' | translate)
              }}</span
            >
          </mat-radio-button>
          <mat-radio-button value="remove" data-cy="remove-radio-button">{{
            'i18n.orderExceptionsPage.remove' | translate
          }}</mat-radio-button>
        </mat-radio-group>
      </p>
    </div>
  </div>

  <span class="button-wrapper">
    <ion-button
      class="usf-fill-green-button"
      *ngIf="exceptionResolution?.partialReserveFlag"
      (click)="clearSubstitute()"
      data-cy="edit-partial-reserve-button"
    >
      Edit
    </ion-button>

    <ng-container *ngIf="!exceptionResolution?.partialReserveFlag">
      <ion-button
        *ngIf="selectedReserveQuantityOption === 'remove'"
        class="usf-fill-green-dsktp-tblt-modal-button"
        (click)="confirmAndSubParitalUnavailable()"
        data-cy="confirm-and-replace-button"
      >
        {{
          exceptionType === exceptionTypes.PRODUCT_UNAVAILABLE
            ? ('i18n.orderExceptionsPage.confirmAndReplace' | translate)
            : ('i18n.orderExceptionsPage.confirmAndSub' | translate)
        }}
      </ion-button>
      <ion-button
        [ngClass]="
          selectedReserveQuantityOption === 'remove'
            ? exceptionResolution?.resolutionType === 'Removed'
              ? 'usf-outline-disabled-button'
              : 'usf-outline-green-dsktp-tblt-modal-button'
            : exceptionResolution?.resolutionType === 'Added to Waitlist' ||
                exceptionResolution?.resolutionType === 'Reserved'
              ? 'usf-fill-disabled-dsktp-tblt-modal-button'
              : 'usf-fill-green-dsktp-tblt-modal-button'
        "
        *ngIf="selectedReserveQuantityOption"
        (click)="confirmPartialUnavailable()"
        data-cy="confirm-partial-unavailable-button"
      >
        Confirm
      </ion-button>
    </ng-container>
  </span>
</div>
